export interface IBackendRouter {
  generate: (a: string, b?: any, c?: any) => string
  getBaseUrl: () => string
  getRoute: (a: string) => string
  getRoutes: () => string
  setBaseUrl: () => void
  setRoute: (a?: any) => void
  setRoutes: () => void
  API_URL: string
}

export interface IExtendedBackendRouter extends IBackendRouter {
  watchlistDashboardOngoing: () => string
  watchlistDashboardCompleted: () => string
  watchlistDashboardCompletedCounters: () => string
}

function extendRouter(Router: IBackendRouter): IExtendedBackendRouter {
  ;(Router as IExtendedBackendRouter).watchlistDashboardOngoing = () =>
    Router.generate('live_market.dashboard.ongoing')
  ;(Router as IExtendedBackendRouter).watchlistDashboardCompleted = () =>
    Router.generate('live_market.dashboard.history')
  ;(Router as IExtendedBackendRouter).watchlistDashboardCompletedCounters =
    () => Router.generate('watchlist.dashboard.completedCounters')

  return Router as IExtendedBackendRouter
}

export default function (): IExtendedBackendRouter {
  if (
    typeof window === 'object' &&
    window !== null &&
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    typeof (<IBackendRouter>window['Routing']) !== 'undefined'
  ) {
    //TODO remove false after window.Translator will be defined
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extendRouter(<IBackendRouter>window['Routing'])
  } else {
    console.info(
      '(!) BackendRouter was not loaded from global scope. Provinding a mock of it instead.'
    )
    return extendRouter({
      generate: (a, b, c) => 'generated-url-for-' + a,
      getBaseUrl: () => 'base-url',
      getRoute: a => 'route-for-' + a,
      getRoutes: () => 'routes',
      setBaseUrl: () => null,
      setRoute: a => null,
      setRoutes: () => null,
      API_URL: ''
    })
  }
}
